// extracted by mini-css-extract-plugin
export default {"title":"RecentCharges_title__nl72j","filtersRow":"RecentCharges_filtersRow__USd4Z"};